import { WeatherSettingsChangeSource } from '@fe/weather';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { MinimumLevelSatellite, MinimumTempSatellite } from '../settings-options';
import { useBooleanSetting, useDropdownSetting, useSliderSetting } from './hooks/useSetting';
import { Checkbox } from '@progress/kendo-react-inputs';
import { SliderWithTooltip } from '../../../../app/components/inputs/SliderWithTooltip';

export default function SatelliteSettings() {
    const satelliteMin = useDropdownSetting(
        MinimumLevelSatellite,
        'radar',
        'satelliteMinLevel',
        WeatherSettingsChangeSource.radarSatellite
    );
    const satelliteMinTemp = useDropdownSetting(
        MinimumTempSatellite,
        'radar',
        'satelliteMinTemp',
        WeatherSettingsChangeSource.radarSatellite
    );

    const satelliteUseTransparency = useBooleanSetting('radar', 'enableSatelliteTransparency', WeatherSettingsChangeSource.radarSatellite);
    const satelliteTransparency = useSliderSetting('radar', 'satelliteTransparency', WeatherSettingsChangeSource.radarSatellite);

    return (
        <div className="d-flex gap-2 flex-column">
            <div>
                <div>Min level to display</div>
                <DropDownList {...satelliteMin} />
            </div>

            <div>
                <div>Min temperature to display</div>
                <DropDownList {...satelliteMinTemp} />
            </div>

            <div className="d-flex gap-2 align-items-center">
                <Checkbox {...satelliteUseTransparency} label={'Enable transparency'} />
                <SliderWithTooltip min={0} max={100} {...satelliteTransparency} className="flex-grow-1" />
            </div>
        </div>
    );
}
